import * as React from "react";
import "./styles.scss";
import {CensusCoolerContext} from "../../providers/CensusCollerProvider";
import {
	DateRangePicker,
	DateRangePickerProps,
	Icon,
	icons,
	InputAddon,
	SelectInput,
	type SelectInputOption,
	TextInput,
	Tooltip,
} from "@vebox/etui-core";
import {Period, PeriodStatus} from "./types";
import {createSelectOption, createSelectOptions, formatDateYYYYmmDD,} from "./utils";
import {StyleProps} from "@vebox/etui-system";
import {Display} from "../../../../../components/Display";
import {ETUI_ICONS_SIZE} from "../../../../../users/UserManagement";

type PeriodSelectionPageProps = {
    showIsRequiredMessage?: boolean;
};

const DATE_PICKER_STYLE: {
    root?: StyleProps;
    inputRoot?: StyleProps;
    input?: StyleProps;
    inputLabel?: StyleProps;
    filterContainer?: StyleProps;
} = {
    input: {
        boxSizing: "border-box",
        height: "44px",
    },
};

export const PeriodSelection: React.FC<PeriodSelectionPageProps> = ({
                                                                        showIsRequiredMessage,
                                                                    }) => {
    const {selectedPeriod, handlePeriodChange, AppTranslations} =
        React.useContext(CensusCoolerContext);
    const [periodStatus, setPeriodStatus] = React.useState<PeriodStatus>();
    const handlePeriodSelectInputChange = (option: SelectInputOption) => {
        setPeriodStatus(handlePeriodChange(option.value));
    };

    const onDatePickerChange: DateRangePickerProps["onChange"] = ({
                                                                      startDate,
                                                                  }): void => {
        setPeriodStatus(
            handlePeriodChange(Period.customDate, startDate, new Date()),
        );
    };

    return (
        <div className={"flx-row gap-15"}>
			<span className={"info-icon"}>
				<Tooltip
                    message={
                        AppTranslations.massiveActions.censusCooler.telemetryComunication
                    }
                    placement={"top"}
                >
					<Icon glyph={icons.INFO_CIRCLE} size={ETUI_ICONS_SIZE}/>
				</Tooltip>
			</span>
            <div className={"cc-input-wrap"}>
                <SelectInput
                    name={"period"}
                    label={AppTranslations.massiveActions.censusCooler.selectPeriod}
                    options={createSelectOptions(AppTranslations)}
                    onChange={handlePeriodSelectInputChange}
                    value={
                        selectedPeriod
                            ? createSelectOption(selectedPeriod?.period, AppTranslations)
                            : null
                    }
                    error={
                        showIsRequiredMessage
                            ? {errorMessage: AppTranslations.feedbackModal.requiredWarning}
                            : undefined
                    }
                    size={"small"}
                />
            </div>
            <Display isVisible={selectedPeriod?.period === Period.customDate}>
                <div className={"cc-input-wrap"}>
                    <DateRangePicker
                        label={AppTranslations.massiveActions.censusCooler.startPeriodDate}
                        onChange={onDatePickerChange}
                        size={"small"}
                        startDate={new Date(selectedPeriod?.startDate)}
                        styles={DATE_PICKER_STYLE}
                        disableRange={true}
                    />
                    <Display isVisible={periodStatus?.status === false}>
                        <p className={"cc-error-message"}>{periodStatus?.errorMessage}</p>
                    </Display>
                </div>
                <div className={"cc-input-wrap"}>
                    <TextInput
                        label={AppTranslations.massiveActions.censusCooler.endOfPeriod}
                        startInputAddon={
                            <InputAddon position={"start"}>
                                <Icon glyph={icons.CALENDAR}/>
                            </InputAddon>
                        }
                        disabled={true}
                        value={formatDateYYYYmmDD(selectedPeriod?.endDate)}
                        size={"small"}
                        styles={DATE_PICKER_STYLE}
                    />
                </div>
            </Display>
        </div>
    );
};
